import React, { useState, useEffect } from "react";
import Markdown from "@sui/chat-ui/es/ChatUI/components/markdown";
import axios from "axios";
import API from "@/api";
import { Spin } from "antd";

function Sqljx(props) {
  const { question_id } = props;
  const [spinning, setSpinning] = useState(true);
  const [jxData, setJxData] = useState("");

  useEffect(() => {
    handleStreamRequest();
  }, []);

  const handleStreamRequest = async () => {
    const url = API.getJxQsSqlData;
    const payload = {
      question_id: question_id,
    };

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          // 如果需要鉴权
          // 'Authorization': 'Bearer token'
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) throw new Error("Network response was not ok");
      setSpinning(false);
      // 1. 获取读取器
      const reader = response.body.getReader();
      const decoder = new TextDecoder("utf-8");
      let resultText = "";

      // 2. 循环读取流
      while (true) {
        const { done, value } = await reader.read();
        if (done) break; // 读取完毕

        // 3. 解码二进制数据
        const chunk = decoder.decode(value, { stream: true });
        // chunk 可能是多行数据，需要按换行符分割
        const lines = chunk.split("\n");

        lines.forEach((line) => {
          if (line.trim().startsWith("data:")) {
            // 去掉 'data:' 前缀
            const jsonString = line.replace(/^data:/, "").trim();
            if (jsonString === "[DONE]") return; // 结束标志

            try {
              const json = JSON.parse(jsonString);
              // 4. 提取增量内容 (delta) 并追加到结果中
              if (json.data && json.data.delta) {
                resultText += json.data.delta;
                // 更新页面显示 (例如 React 的 setState)
                setJxData(resultText);
              }
            } catch (e) {
              console.error("解析 JSON 失败:", e);
            }
          }
        });
      }
    } catch (error) {
      console.error("请求失败:", error);
    }
  };

  return (
    <div className="sqlContent">
      <Spin spinning={spinning}>
        <div className="jxContent">
          <Markdown
            data={{
              think: null,
              thinking: false,
              content: jxData,
            }}
          ></Markdown>
        </div>
      </Spin>
    </div>
  );
}
export default Sqljx;
